import React from 'react';
import cx from 'classnames';

import s from './index.module.css';

const TERMS_OF_USE_LINK = 'https://smartbe.ru/privacy';

const TermsOfUse = ({ className }) => (
  <div className={cx(s.wrapper, { [className]: !!className })}>
    Начиная чат, вы соглашаетесь с&nbsp;
    <a className={s.link} href={TERMS_OF_USE_LINK} target="_blank" rel="noopener noreferrer">пользовательским соглашением</a>
  </div>
);

export default TermsOfUse;
